import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DFMonthlyDataDto, DFMonthlyDataRequest } from 'app/df-management/shared/df-admin-country.model';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { CalendarStatusService } from '../../calendar-status.service';
import { CalendarService } from '../../calendar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-calendar',
  templateUrl: './add-calendar.component.html',
  styleUrls: ['./add-calendar.component.scss']
})
export class AddCalendarComponent implements OnInit {
  private readonly MAX_BUFFER_DAYS = 7;
  isDataSavedPopup = false;
  selectedYear: number;
  bufferDays = null;
  countryCode: string;
  formType: string;
  months: DFMonthlyDataDto[] = [];
  storedMonths: DFMonthlyDataDto[] = [];
  editCalDetails: DFMonthlyDataRequest[];

  dateConfig = {
    appendTo: 'body',
    drops: 'down',
    firstDayOfWeek: 'mo',
    format: 'YYYY-MM-DD',
    max: null,
    min: null,
    disableKeypress: false,
    unSelectOnClick: true,
  };

  dayConfig = {
    appendTo: 'body',
    drops: 'down',
    firstDayOfWeek: 'mo',
    format: 'YYYY-MM-DD',
    max: null,
    min: null,
    disableKeypress: false,
    unSelectOnClick: true,
  }

  datConfig = {
    appendTo: 'body',
    drops: 'down',
    firstDayOfWeek: 'mo',
    format: 'YYYY-MM-DD',
    max: null,
    min: null,
    disableKeypress: false,
    unSelectOnClick: true,
  }

  constructor(public navigationService: NavigationService,
    private router: Router,
    private dfManagementService: DfManagementService,
    private calendarstatusService: CalendarStatusService,
    private calendarService: CalendarService
  ) { }

  ngOnInit(): void {
    this.selectedYear = this.calendarService.getSelectedYear();
    this.countryCode = this.calendarService.getSelectedCountry();
    this.formType = this.calendarService.getFormType();
    this.calendarService.calendarData$.subscribe((result: Object) => {
      this.storedMonths = result['months'];
      this.bufferDays = result['bufferDays'];
    });
    if (!this.storedMonths || !this.storedMonths.length) {
      this.dfManagementService.getFlexibleCalendarData(this.countryCode, this.selectedYear).subscribe((response: DFMonthlyDataRequest[]) => {
        if (response) {
          this.bufferDays = response[0]?.voucher_grace_days;
          this.months = response.map(item => DFMonthlyDataDto.fromDto(item));
        }
      },
      (error: any) => {
        console.log('::::: Error: ::::::', error);
      })
    } else {
      this.months = this.storedMonths;
    }
  }

  formatStringDate(date: string) {
    if (!date) {
      return null;
    }
    return this.formatDate(new Date(date));
  }

  keyValidations(event: KeyboardEvent) {
    const allowedKeys = ['1', '2', '3', '4', '5', '6', '7', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const currentValue = (event.target as HTMLInputElement).value;

    if (!allowedKeys.includes(event.key) || (currentValue.length === 1 && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key))) {
        event.preventDefault();
    }
}

voucherDatesCalculation() {
  if (isNaN(this.bufferDays)) {
    return;
  }
  this.recalculateVoucherDates();
}

  recalculateVoucherDates() {
    if (isNaN(this.bufferDays)) {
      return;
    }
    if (this.bufferDays > this.MAX_BUFFER_DAYS) {
            this.bufferDays = null;
            console.error(`Buffer days cannot be greater than ${this.MAX_BUFFER_DAYS}.`);
            return;
    }
    this.months.forEach(month => {
            this.updateVoucherJobRunDate(month);
    });
}



updateNumberOfDays(month: DFMonthlyDataDto, index: number) {
  const startDate = new Date(month.monthStartDate);
  const endDate = new Date(month.monthEndDate);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    console.error('Invalid date');
    return;
  }

  if (index > 0) {
    const previousMonth = this.months[index - 1];
    const previousMonthEndDate = new Date(previousMonth.monthEndDate);

    if (startDate <= previousMonthEndDate) {
        console.warn(`Start date (${month.monthStartDate}) should be after end date of the previous month (${previousMonth.monthEndDate})`);
        month.monthStartDate = null;
        return;
    }
}

  if (startDate >= endDate) {
    console.warn(`Start date (${month.monthStartDate}) should be before end date (${month.monthEndDate})`);
    month.monthStartDate = this.formatStringDate(new Date(month.monthStartDate).toDateString());
    return;
  }

  const timeDiff = endDate.getTime() - startDate.getTime();
  const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
  month.numberOfDays = daysDiff;
  this.updateMinEndDate(month, index);

  if (index < this.months.length - 1) {
    const nextMonth = this.months[index + 1];
    const newNextMonthStartDate = new Date(endDate);
    newNextMonthStartDate.setDate(endDate.getDate() + 1);
    nextMonth.monthStartDate = this.formatStringDate(newNextMonthStartDate.toDateString());

    nextMonth.monthEndDate = '';
    nextMonth.minEndDate = '';
    nextMonth.numberOfDays = null;
    nextMonth.voucherUpdateDate = '';

    console.log(`Updated start date of ${nextMonth.month} to ${nextMonth.monthStartDate}`);
  }

  this.updateVoucherJobRunDate(month);
}

updateVoucherJobRunDate(month: DFMonthlyDataDto) {
  if (null === month.monthEndDate) {
    return null;
  }
  const endDate = new Date(month.monthEndDate);

  if (isNaN(endDate.getTime())) {
    console.error('Invalid end date');
    return;
  }

  const bufferDays = parseInt(this.bufferDays, 10);
  if (!isNaN(bufferDays)) {
    endDate.setDate(endDate.getDate() + bufferDays);
    month.voucherUpdateDate = this.formatStringDate(endDate.toDateString());
  } else {
    console.error('Invalid buffer days');
  }
}

formatDate(date: Date): string {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  month = month.length === 1 ? '0' + month : month;
  day = day.length === 1 ? '0' + day : day;
  return year + '-' + month + '-' + day;
}

updateMinEndDate(month: DFMonthlyDataDto, index: number) {
  if (month.monthStartDate) {
    const startDate = new Date(month.monthStartDate);
    startDate.setDate(startDate.getDate() + 1);
    month.minEndDate = this.formatDate(startDate);
  } else {
    month.minEndDate = '';
  }
}

areAllDatesFilled(): boolean {
  return this.months.every(month => month.monthStartDate && month.monthEndDate && month.voucherUpdateDate);
}

  goBackAdmin() {
    this.navigationService.dfAdminManagemnt().list().go();
  }

  saveCalendar() {
    this.countryCode = this.calendarService.getSelectedCountry();
    this.months.forEach(month => {month.voucherGraceDays = this.bufferDays});
    this.calendarService.setCalendarData(this.months, this.selectedYear, this.bufferDays);
    this.calendarstatusService.updateCalendarStatus(true);
    this.isDataSavedPopup = true;
  }

  saveCalendarToDatabase() {
    const formType = this.calendarService.getFormType();
    this.months.forEach(month => {month.voucherGraceDays = this.bufferDays});
    if ('ViewCountry' === formType) {
      this.editCalDetails =
       this.months.map(month => DFMonthlyDataDto.toDto(month));
        this.dfManagementService.addFlexibleCalendarData(this.countryCode, this.editCalDetails).subscribe((response: any) => {
          if (response) {
            this.calendarService.setCalendarData([], null, null);
            this.isDataSavedPopup = true;
          }
        },
        (error: any) => {
          console.error('Error:', error);
        });
    }
  }

  saveToLocal(key: string, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  retrieveFromLocal(key: string): any {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }

  confirmDownloadReportButton() {
    this.isDataSavedPopup = false;

    this.navigationService.dfAdminManagemnt().adminlist().go();
    if ('ViewCountry' === this.formType) {
      this.setCalendarValue(false);
    } else if ('OnBoardCountry' === this.formType) {
      this.setCalendarValue(true);
    }
  }

  setCalendarValue(value: boolean) {
    setTimeout(() => {
      this.calendarService.sendCalendarValue(value);
    }, 1000);
  }

  cancel() {
    if ('ViewCountry' === this.formType) {
      this.calendarService.setCalendarData([], null, null);
      this.calendarService.setSelectedCountry(null);
    } else if ('OnBoardCountry' === this.formType) {
      this.setCalendarValue(true);
    }
    this.navigationService.dfAdminManagemnt().adminlist().go();
  }
}
